import React from "react";
import { Stack, Title, Text, Divider } from "@mantine/core";
import { DisplayLinkItem } from "../../DisplayActivations";
import { VenueDisplaySectionProps } from "./VenueDisplaySection.types";

export const VenueDisplaySection: React.FC<VenueDisplaySectionProps> = ({
  venue,
  onLinkDisplay,
  isLinking,
  linkingDisplayId,
}) => {
  const displays = venue.displays || [];

  if (displays.length === 0) {
    return null; // Don't render venues with no displays
  }

  return (
    <Stack gap="md">
      <div>
        <Title order={3} size="h4" c="gray.8">
          {venue.name || "Unnamed Venue"}
        </Title>
        {venue.description && (
          <Text size="sm" c="dimmed" mt="xs">
            {venue.description}
          </Text>
        )}
        {venue.city && venue.stateProvince && (
          <Text size="xs" c="dimmed" mt="xs">
            {venue.city}, {venue.stateProvince}
          </Text>
        )}
      </div>

      <Stack gap="sm">
        {displays.map((display) => (
          <DisplayLinkItem
            key={display.id}
            display={display}
            onLink={onLinkDisplay}
            isLinking={isLinking}
            isCurrentlyLinking={linkingDisplayId === display.id}
          />
        ))}
      </Stack>

      <Divider />
    </Stack>
  );
};
